import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export default function About() {
  const { t } = useTranslation();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 lg:py-36 bg-[#FAF7F2]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-6 relative"
        >
          <div className="overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_vivendi-sailing/artifacts/rj8ork2n_IMG_20250921_183023_472.webp"
              alt="Sunset on Lake Ohrid from the deck"
              className="block w-full h-auto"
            />
          </div>
          <div className="absolute -bottom-10 -right-4 lg:-right-10 bg-[#0A1B35] text-white px-8 py-7 max-w-[260px] shadow-2xl">
            <div className="font-serif-display text-5xl leading-none">2025</div>
            <div className="overline text-[#D1BFAe] mt-2">{t("about.est_year")}</div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="lg:col-span-6 lg:pl-8"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#0A1B35]" />
            <span className="overline text-[#0A1B35]">{t("about.eyebrow")}</span>
          </div>

          <h2
            data-testid="about-title"
            className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A1B35] leading-[1.05]"
          >
            {t("about.title_pre")}
            <br />
            {t("about.title_join")} <em className="italic">{t("about.title_em")}</em>
            {t("about.title_dot")}
          </h2>

          <div className="mt-8 space-y-5 text-[#4B5563] font-light leading-relaxed">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-[#0A1B35]/10 pt-8">
            {[
              { n: "3M+", l: t("about.stat_age") },
              { n: "2", l: t("about.stat_boats") },
              { n: "∞", l: t("about.stat_sunsets") },
            ].map((s, i) => (
              <div key={i}>
                <div className="font-serif-display text-3xl lg:text-4xl text-[#0A1B35]">
                  {s.n}
                </div>
                <div className="overline text-[#4B5563] mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
